export const normalizeTel = (tel: string) => tel.replace(/[\s-/]/g, '');
export const normalizeWa = (wa: string) => wa.replace(/[+\s]/g, '');
